/**
 * Removes a single trailing slash from a URL, if present.
 */
export function stripTrailingSlash(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}
